import {
    AUTH, AuthState, AuthActionTypes
} from './types';

export const initialState: AuthState = {
    pending: false,
    error: null
};

export const authReducer = (state = initialState, action: AuthActionTypes) => {
    const NewState = { ...state }
    switch (action.type) {
        case AUTH.LOGIN_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error
            }
        case AUTH.LOGIN_PENDING:
            return {
                ...state,
                pending: true,
                loginRequest: action.payload
            }
        case AUTH.LOGIN_SUCCESS:
            return {
                ...state,
                pending: false,
                loginResponse: action.login
            }
        case AUTH.REGISTER_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error
            }
        case AUTH.REGISTER:
            return {
                ...state,
                pending: true,
                registerRequest: action.payload
            }
        case AUTH.REGISTER_SUCCESS:
            return {
                ...state,
                pending: false,
                registerResponse: action.register
            }
        default:
            return NewState;

    }
};